module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_c('v-badge', {
      attrs: {
        "overlap": ""
      },
      scopedSlots: _vm._u([(_vm.enabledFilter['tab-' + n]) ? {
        key: "badge",
        fn: function() {
          return [_c('v-icon', {
            staticClass: "caption"
          }, [_vm._v("filter_list")])]
        },
        proxy: true
      } : null], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "pa-2"
    }, [_vm._v(_vm._s(tabItem + ' (' + (tabItem === 'All Open' ? _vm.openTickets.length : _vm.closedTickets.length) + ')'))])])], 1)
  }), 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [(_vm.choosenView === 'card') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": "",
        "mx-auto": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pt-3"
    }, [_c('v-data-iterator', {
      attrs: {
        "items": tabItem === 'All Open' ? _vm.openTickets : _vm.closedTickets,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function(props) {
          return [_c('v-layout', [_c('v-flex', {
            staticClass: "pb-2",
            attrs: {
              "xs12": ""
            }
          }, [_c('v-card', {
            staticClass: "grey lighten-4"
          }, [_c('v-card-text', {
            staticClass: "py-0"
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs10": "",
              "sm11": ""
            }
          }, [_c('div', {
            staticClass: "pt-3 subheading"
          }, [_c('b', [_vm._v(_vm._s('#' + props.item.ticket_id + ' - ' + props.item.dept_name + ' - ' + props.item.cat))])])]), _vm._v(" "), _c('v-flex', {
            staticClass: "pa-0",
            attrs: {
              "xs2": "",
              "sm1": ""
            }
          }, [_c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "right": "",
              "close-on-content-click": false
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-group', {
            attrs: {
              "no-action": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function() {
                return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
              },
              proxy: true
            }], null, true),
            model: {
              value: (_vm.lSupport.status),
              callback: function($$v) {
                _vm.$set(_vm.lSupport, "status", $$v)
              },
              expression: "lSupport.status"
            }
          }, [_vm._v(" "), _vm._l((_vm.statusList), function(status, i) {
            return (((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')) ? _c('v-list-tile', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.prepareTicketStatus(props.item, status)
                }
              }
            }, [_c('v-list-tile-title', [_vm._v("\n                                    " + _vm._s(status) + "\n                                  ")])], 1) : _vm._e()
          })], 2), _vm._v(" "), (props.item.status !== 'Completed' && props.item.status !== 'Cancelled') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTicketStatus(props.item, 'Comment')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1), _vm._v(" "), (props.item.status === 'New' && props.item.assigned_to_name === null) ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.deleteTicket(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs12": ""
            }
          }, [_c('div', {
            staticClass: "pb-2"
          }, [_vm._v("\n                            " + _vm._s(props.item.description.substring(0, 150) + '...') + "\n                          ")]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs12": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs6": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs3": "",
              "sm2": ""
            }
          }, [_c('v-avatar', {
            staticClass: "pt-0",
            attrs: {
              "slot": "activator",
              "size": "24px"
            },
            slot: "activator"
          }, [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.created_avatar_url
            }
          })])], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "caption",
            attrs: {
              "xs9": "",
              "sm10": ""
            }
          }, [_c('div', {
            staticClass: "primary--text"
          }, [_c('strong', [_vm._v("Created by")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.item.created_by_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.created_dt)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs6": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs3": "",
              "sm2": ""
            }
          }, [_c('v-avatar', {
            staticClass: "pt-0",
            attrs: {
              "slot": "activator",
              "size": "24px"
            },
            slot: "activator"
          }, [(props.item.assigned_to) ? _c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.assigned_avatar_url
            }
          }) : _c('v-icon', {
            staticClass: "grey"
          }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "caption",
            attrs: {
              "xs9": "",
              "sm10": ""
            }
          }, [_c('div', {
            staticClass: "primary--text"
          }, [_c('strong', [_vm._v("Assigned to")])]), _vm._v(" "), (props.item.assigned_to) ? _c('div', [_c('div', [_vm._v(_vm._s(props.item.assigned_to_name))]), _vm._v(" "), (props.item.assigned_dt) ? _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.assigned_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.assigned_dt)))]) : _vm._e()]) : _c('div', [_vm._v("NA")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "subheading",
            attrs: {
              "xs12": ""
            }
          }, [_c('v-divider', {
            staticClass: "pt-1"
          }), _vm._v(" "), _c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "xs5": ""
            }
          }, [_c('div', {
            staticClass: "pa-1",
            class: props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text'))
          }, [_c('span', {
            staticClass: "primary--text"
          }, [_vm._v(" Status: ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(" " + _vm._s(props.item.status) + " ")])])]), _vm._v(" "), _c('v-flex', {
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "xs5": ""
            }
          }, [_c('div', {
            staticClass: "pa-1"
          }, [_c('span', {
            staticClass: "primary--text"
          }, [_vm._v(" Priority: ")]), _vm._v(" "), _c('span', {
            staticClass: "green--text",
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(" " + _vm._s(props.item.priority) + " ")])])]), _vm._v(" "), (props.item.tot_files) ? _c('v-flex', {
            staticClass: "pa-1",
            attrs: {
              "xs2": ""
            },
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-badge', {
            attrs: {
              "overlap": "",
              "color": "info"
            },
            scopedSlots: _vm._u([{
              key: "badge",
              fn: function() {
                return [_c('span', {
                  staticClass: "caption"
                }, [_vm._v(_vm._s(props.item.tot_files))])]
              },
              proxy: true
            }], null, true)
          }, [_vm._v(" "), _c('v-icon', {
            staticClass: "pa-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("attach_file")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenView === 'list') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mx-auto": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.ticketHead,
        "items": tabItem === 'All Open' ? _vm.openTickets : _vm.closedTickets,
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.ticket_id))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_dt)))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.dept_name))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.cat))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.description.substring(0, 150) + '...'))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.created_by_name))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.assigned_to ? props.item.assigned_to_name : 'NA'))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.priority))]), _vm._v(" "), _c('td', {
            class: 'pa-2 ' + (props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text')))
          }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [(props.item.tot_files) ? _c('v-badge', {
            attrs: {
              "overlap": "",
              "color": "info"
            },
            scopedSlots: _vm._u([{
              key: "badge",
              fn: function() {
                return [_c('span', {
                  staticClass: "caption"
                }, [_c('strong', [_vm._v(_vm._s(props.item.tot_files))])])]
              },
              proxy: true
            }], null, true)
          }, [_vm._v(" "), _c('v-icon', {
            staticClass: "pa-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("attach_file")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "top": "",
              "right": "",
              "close-on-content-click": false
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-group', {
            attrs: {
              "no-action": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function() {
                return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
              },
              proxy: true
            }], null, true),
            model: {
              value: (_vm.lSupport.status),
              callback: function($$v) {
                _vm.$set(_vm.lSupport, "status", $$v)
              },
              expression: "lSupport.status"
            }
          }, [_vm._v(" "), _vm._l((_vm.statusList), function(status, i) {
            return (((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')) ? _c('v-list-tile', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.prepareTicketStatus(props.item, status)
                }
              }
            }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(status) + "\n                    ")])], 1) : _vm._e()
          })], 2), _vm._v(" "), (props.item.status !== 'Completed' && props.item.status !== 'Cancelled') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTicketStatus(props.item, 'Comment')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1), _vm._v(" "), (props.item.status === 'New' && props.item.assigned_to_name === null) ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.deleteTicket(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1)])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-speed-dial', {
    staticStyle: {
      "position": "fixed",
      "top": "90px",
      "right": "10px"
    },
    attrs: {
      "direction": _vm.$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'
    },
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "fab": "",
      "color": "accent"
    },
    slot: "activator",
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-icon', [_vm._v("remove_red_eye")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'card' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('card')
            }
          }
        }, on), [_c('v-icon', [_vm._v("filter_frames")])], 1)]
      }
    }], null, false, 2865765141)
  }, [_vm._v(" "), _c('span', [_vm._v("Card view")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'list' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('list')
            }
          }
        }, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }], null, false, 1363469397)
  }, [_vm._v(" "), _c('span', [_vm._v("List view")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'Create' || _vm.lAction === 'Update') ? _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveTicket(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 ml-3"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Request') + "\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "label": "Department",
      "item-value": "dept_id",
      "item-text": "dept_name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadCategories(_vm.lSupport.dep_pair)
      }
    },
    model: {
      value: (_vm.lSupport.dep_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "dep_pair", $$v)
      },
      expression: "lSupport.dep_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": _vm.catList,
      "item-value": "cat_id",
      "item-text": "cat",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSubCatList(_vm.lSupport.cat_pair)
      }
    },
    model: {
      value: (_vm.lSupport.cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "cat_pair", $$v)
      },
      expression: "lSupport.cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sub Category",
      "items": _vm.subCatList,
      "item-value": "sub_cat_id",
      "item-text": "sub_cat",
      "return-object": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSubCatList(_vm.lSupport.sub_cat_pair)
      }
    },
    model: {
      value: (_vm.lSupport.sub_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "sub_cat_pair", $$v)
      },
      expression: "lSupport.sub_cat_pair"
    }
  })], 1), _vm._v(" "), (_vm.lSupport.sub_cat_pair.sub_cat === 'Others') ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Others",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lSupport.others),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "others", $$v)
      },
      expression: "lSupport.others"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.assignUserList,
      "label": "Assigned to",
      "item-text": "emp_name_with_id",
      "item-value": "emp_id",
      "hide-details": "",
      "return-object": "",
      "disabled": _vm.lSupport.comm_id != 126
    },
    model: {
      value: (_vm.lSupport.assigned_to_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "assigned_to_pair", $$v)
      },
      expression: "lSupport.assigned_to_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.priorityList,
      "label": "Priority",
      "item-text": "priority",
      "item-value": "priority_id",
      "return-object": "",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "disabled": _vm.lSupport.status === 'Completed' || _vm.lSupport.status === 'Cancelled'
    },
    model: {
      value: (_vm.lSupport.priority_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "priority_pair", $$v)
      },
      expression: "lSupport.priority_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['New', 'In Progress', 'On-Hold', 'Need More Info.', 'Job-Done', 'Completed', 'Cancelled', 'Reopen'],
      "label": "Status",
      "hide-details": "",
      "disabled": _vm.lAction === 'Create' || _vm.lAction === 'Update'
    },
    model: {
      value: (_vm.lSupport.status),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "status", $$v)
      },
      expression: "lSupport.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Description",
      "rows": "2",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "3000",
      "box": ""
    },
    model: {
      value: (_vm.lSupport.description),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "description", $$v)
      },
      expression: "lSupport.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.planned_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "planned_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "planned_start_dt", $event)
      }
    },
    model: {
      value: (_vm.planStartDt),
      callback: function($$v) {
        _vm.planStartDt = $$v
      },
      expression: "planStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Planned Start Date",
      "rules": [_vm.rules.required],
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.planned_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_start_dt", $$v)
      },
      expression: "lSupport.planned_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.planned_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_start_dt", $$v)
      },
      expression: "lSupport.planned_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planStartDt.save(_vm.lSupport.planned_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.planned_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "planned_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "planned_end_dt", $event)
      }
    },
    model: {
      value: (_vm.planEndDt),
      callback: function($$v) {
        _vm.planEndDt = $$v
      },
      expression: "planEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Planned End Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_end_dt", $$v)
      },
      expression: "lSupport.planned_end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.lSupport.planned_start_dt,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_end_dt", $$v)
      },
      expression: "lSupport.planned_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planEndDt.save(_vm.lSupport.planned_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "actStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.act_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "act_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "act_start_dt", $event)
      }
    },
    model: {
      value: (_vm.actStartDt),
      callback: function($$v) {
        _vm.actStartDt = $$v
      },
      expression: "actStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual Start Date",
      "append-icon": "event",
      "disabled": "",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.act_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_start_dt", $$v)
      },
      expression: "lSupport.act_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.act_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_start_dt", $$v)
      },
      expression: "lSupport.act_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.actStartDt.save(_vm.lSupport.act_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "actEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.act_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "act_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "act_end_dt", $event)
      }
    },
    model: {
      value: (_vm.actEndDt),
      callback: function($$v) {
        _vm.actEndDt = $$v
      },
      expression: "actEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual End Date",
      "disabled": "",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.act_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_end_dt", $$v)
      },
      expression: "lSupport.act_end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.act_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_end_dt", $$v)
      },
      expression: "lSupport.act_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.actEndDt.save(_vm.lSupport.act_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "jobDoneDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.job_done_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "job_done_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "job_done_dt", $event)
      }
    },
    model: {
      value: (_vm.jobDoneDt),
      callback: function($$v) {
        _vm.jobDoneDt = $$v
      },
      expression: "jobDoneDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Job Done Date",
      "append-icon": "event",
      "disabled": "",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.job_done_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "job_done_dt", $$v)
      },
      expression: "lSupport.job_done_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.lSupport.job_done_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "job_done_dt", $$v)
      },
      expression: "lSupport.job_done_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.jobDoneDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.jobDoneDt.save(_vm.lSupport.job_done_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lSupport)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lSupport.files && _vm.lSupport.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lSupport.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [(!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.STATIC_FILES_DIR + file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "ml-0 info lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "ml-0"
    }, [_vm._v(_vm._s(file.file_name))])])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved || _vm.lSupport.status === 'Completed' || _vm.lSupport.status === 'Cancelled'
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDlgStatus),
      callback: function($$v) {
        _vm.showDlgStatus = $$v
      },
      expression: "showDlgStatus"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 title"
  }, [_vm._v("\n      " + _vm._s('Add comments for ' + _vm.lTicketStatus.action) + "\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "black--text"
  }, [(_vm.lTicketStatus.action === 'Completed') ? _c('v-flex', {
    staticClass: "pt-2 pl-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lTicketStatus.planned_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTicketStatus, "planned_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTicketStatus, "planned_end_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Completed date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lTicketStatus.planned_end_dt),
            callback: function($$v) {
              _vm.$set(_vm.lTicketStatus, "planned_end_dt", $$v)
            },
            expression: "lTicketStatus.planned_end_dt"
          }
        }, on))]
      }
    }], null, false, 1026145621),
    model: {
      value: (_vm.dlgEndDate),
      callback: function($$v) {
        _vm.dlgEndDate = $$v
      },
      expression: "dlgEndDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "max": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTicketStatus.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lTicketStatus, "planned_end_dt", $$v)
      },
      expression: "lTicketStatus.planned_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndDate.save(_vm.lTicketStatus.planned_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outline": "",
      "placeholder": _vm.placeHolder,
      "maxlength": "250"
    },
    model: {
      value: (_vm.lTicketStatus.notes),
      callback: function($$v) {
        _vm.$set(_vm.lTicketStatus, "notes", $$v)
      },
      expression: "lTicketStatus.notes"
    }
  })], 1), _vm._v(" "), (_vm.lTicketStatus.action === 'Comment') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "statusFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromBrowser(_vm.lTicketStatus)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lTicketStatus.files && _vm.lTicketStatus.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lTicketStatus.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n          " + _vm._s(file.file_name) + "\n          "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.handy.loadImg(file.file_url, true),
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "ml-1 info grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("Attachment(images, pdf, doc, word, excel) if any")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDlgStatus = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.postTicketStatus()
      }
    }
  }, [_vm._v("submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title info lighten-1"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pl-0 pr-4 py-3"
  }, [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lTimeLine), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lTimeLine.length - 1 ? 'pb-0' : '',
      attrs: {
        "small": "",
        "id": 'timeline_' + n
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('v-avatar', [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + timeline.avatar_url
            }
          })])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticClass: "grey lighten-4"
    }, [(timeline.action === 'Ticket Updated') ? _c('div', [_c('v-card-title', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(timeline.action) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0 pb-2"
    }, [(timeline.notes !== '') ? _c('div', [(timeline.action === 'Ticket Updated') ? _c('div', [(timeline.assign_comments !== '') ? _c('div', {
      staticClass: "pb-1"
    }, [(timeline.assign_comments !== '') ? _c('b', [_vm._v("Assignee Comments: ")]) : _vm._e(), _vm._v(_vm._s(timeline.assign_comments) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Notes: ")]), _vm._v(" "), _vm._l((timeline.timeLineNote), function(note, i) {
      return _c('div', {
        key: i
      }, [(note) ? _c('span', [_vm._v(_vm._s(i + 1 + '. ' + note))]) : _vm._e()])
    })], 2)]) : _c('div', {
      staticClass: "pb-1"
    }, [_c('b', [_vm._v("Notes: ")]), _vm._v(_vm._s(timeline.notes) + "\n                ")])]) : _c('div', [(timeline.is_updated_by_sv_user === false) ? _c('div', [_c('b', [_vm._v("Assigned to: ")]), _vm._v(_vm._s(timeline.assigned_to_name))]) : _vm._e(), _vm._v(" "), (timeline.assign_comments !== '') ? _c('div', {
      staticClass: "pb-1"
    }, [(timeline.assign_comments !== '') ? _c('b', [_vm._v("Assignee Comments: ")]) : _vm._e(), _vm._v(_vm._s(timeline.assign_comments) + "\n                ")]) : _vm._e()])])], 1) : _c('div', [_c('v-card-title', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(timeline.action) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0 pb-2"
    }, [(timeline.action === 'Assigned' || timeline.is_updated_by_sv_user === false) ? _c('div', [_c('b', [_vm._v("Assigned to: ")]), _vm._v(" " + _vm._s(timeline.assigned_to_name))]) : _vm._e(), _vm._v(" "), (timeline.action === 'Ticket Created') ? _c('div', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(timeline.notes))]) : _c('div', [_c('b', [_vm._v("Comments: ")]), _vm._v(_vm._s(timeline.notes))])])], 1), _vm._v(" "), (_vm.lTimeLine.attachImages && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id; }).length ||
      _vm.lTimeLine.attachFile && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id; })) ? _c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "grid-list-sm": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.lTimeLine.attachImages.length && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action; }).length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "ml-1",
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                    Image Attachments\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      directives: [{
        name: "viewer",
        rawName: "v-viewer",
        value: (_vm.options),
        expression: "options"
      }],
      staticClass: "clearfix"
    }, [_vm._l((_vm.lTimeLine.attachImages), function(file, index) {
      return [((file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)) ? _c('span', [_c('img', {
        key: index,
        staticClass: "ma-1",
        staticStyle: {
          "display": "inline-block",
          "cursor": "pointer"
        },
        attrs: {
          "width": "80px",
          "src": _vm.config.STATIC_FILES_DIR + file.file_url,
          "data-source": _vm.config.STATIC_FILES_DIR + file.file_url
        }
      })]) : _vm._e()]
    })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.lTimeLine.attachFile.length && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action; }).length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "ml-1",
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                    Other Attachments\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, _vm._l((_vm.lTimeLine.attachFile), function(file, index) {
      return _c('span', {
        key: index
      }, [((file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)) ? _c('v-chip', [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": _vm.config.STATIC_FILES_DIR + file.file_url,
          "download": ""
        }
      }, [_c('v-btn', {
        staticClass: "ml-0 pa-0 info lighten-1 grey--text text--lighten-4",
        attrs: {
          "small": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("file_download")])], 1)], 1), _vm._v("\n                    " + _vm._s(file.file_name) + "\n                  ")]) : _vm._e()], 1)
    }), 0)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "caption pa-2"
    }, [_vm._v("\n        " + _vm._s(timeline.created_by_name) + "\n        "), _c('span', {
      staticClass: "grey--text pl-2"
    }, [_vm._v(_vm._s(_vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text"
  }, [_vm._v("Filter by attributes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "label": "Department",
      "item-text": "dept_name",
      "item-value": "dept_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadCategories(_vm.filterListByTab[_vm.tab].ticket_dept_list)
      }
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_dept_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_dept_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_dept_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.catList,
      "label": "Category",
      "item-text": "cat",
      "item-value": "cat_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_cat_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Priority",
      "items": _vm.priorityList,
      "item-text": "priority",
      "item-value": "priority_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].priority_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "priority_list", $$v)
      },
      expression: "filterListByTab[tab].priority_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.filterStatus,
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_status_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_status_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_status_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by people")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Created by",
      "items": _vm.mcList,
      "item-text": "user_name",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].created_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "created_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].created_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.assignUserList,
      "label": "Assigned to",
      "item-text": "emp_name_with_id",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].assigned_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "assigned_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].assigned_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by date")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDate),
      callback: function($$v) {
        _vm.dlgFromDate = $$v
      },
      expression: "dlgFromDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due from",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDate.save(_vm.filterListByTab[_vm.tab].from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDate),
      callback: function($$v) {
        _vm.dlgToDate = $$v
      },
      expression: "dlgToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due till",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].end_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $$v)
      },
      expression: "filterListByTab[tab].end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].end_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $$v)
      },
      expression: "filterListByTab[tab].end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDate.save(_vm.filterListByTab[_vm.tab].end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:25px;' : 'bottom:15px; left:315px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareFilter()
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(_vm.enabledFilter[this.tab]) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e2e417a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackOfficeSup.vue
// module id = 814
// module chunks = 7